import Avatar, { AvatarPerson, personLabel } from './Avatar.tsx';
import classnames from '../utils/classnames.tsx';

const STACKED_AVATAR_CLASSNAME =
    '-mr-2 border-0 bg-surface-strong text-content-medium ring-2 ring-surface-weak last:mr-0';

export interface AvatarStackProps {
    people: AvatarPerson[];
    max?: number;
    className?: string;
}

const AvatarStack = ({ people, max = 2, className }: AvatarStackProps) => {
    const shown = people.slice(0, max);
    const hidden = people.slice(max);

    return (
        <span className={classnames('flex flex-none items-center', className)}>
            {shown.map((person, index) => (
                <Avatar key={index} person={person} className={STACKED_AVATAR_CLASSNAME} />
            ))}
            {hidden.length > 0 && (
                <Avatar
                    className={classnames(STACKED_AVATAR_CLASSNAME, 'text-content-default')}
                    title={hidden.map(personLabel).join(', ')}
                >
                    +{hidden.length}
                </Avatar>
            )}
        </span>
    );
};

export default AvatarStack;
